import {NEXT_PUBLIC_STATIC_HOST} from 'core/helpers/env';

type TOptionsParam = {
    width?: number;
    height?: number;
    isWebp?: boolean;
};

export const getMediaSrc = (path: string, options?: TOptionsParam): string => {
    if (!path) {
        return '';
    }

    // если путь уже содержит полный URL, возвращаем как есть
    if (path.startsWith('http://') || path.startsWith('https://')) {
        return path;
    }

    let sizes = '';

    if (options) {
        sizes = `@${options.width ?? ''}${options.height ? 'x' + options.height : ''}`;
    }

    // добавляем webp формат только если это явно запрошено или если нет других параметров
    const webpParam = false !== options?.isWebp ? '?fmt=webp' : '';

    return `${NEXT_PUBLIC_STATIC_HOST}${path}${sizes}${webpParam}`;
};
